import React from "react";
import { Button, Typography } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { Flex } from "../../Flex";
import { AnimatedModal } from "../AnimatedModal";
import style from './style.module.scss';

interface ModalWrapperProps {
    isOpen: boolean;
    toggleModal?: (nextOpenState: boolean) => void; // Optional: it should be the caller's perogative on when the modal closes
    children: any;
    label?: any;
    height?: string | number;
    width?: string | number;
    padding?: string | number;
    borderRadius?: string | number;
    closerStyle?: "done-button" | "button" | "x-icon" | "none";
    closerLabel?: string;
    manageScroll?: boolean;
    withHeader?: boolean;
}

export const ModalWrapper = React.memo((props: ModalWrapperProps) => {
    const {
        isOpen,
        toggleModal = () => { },
        children,
        label,
        height = "auto",
        width = "750px",
        closerStyle = "x-icon",
        closerLabel = null,
        manageScroll = true,
        borderRadius = 1,
        padding = 15,
        withHeader = true,
    } = props;

    const Header = () => (
        <Flex
            justify="space-between"
            align="center"
            style={{
                padding: '10px',
                // borderBottom: "1px solid #dadfe4",
            }}
        >
            <Typography variant="h5" style={{ color: "#516f90" }}>
                {label || ""}
            </Typography>
            {closerStyle === "x-icon" ? (
                <div onClick={() => toggleModal(false)}>
                    <CloseRounded style={{ color: "#000000", cursor: 'pointer' }} />
                </div>
            ) : null}
        </Flex>
    );

    const CloseIcon = () => (
        <div onClick={() => toggleModal(false)} style={{ position: 'absolute', top: 10, right: 10 }}>
            <CloseRounded style={{ color: "#000000", cursor: 'pointer' }} />
        </div>
    );

    return (
        <AnimatedModal open={isOpen} onClose={() => toggleModal(false)}>
            <div
                className={style.wrapper}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    background: "#fcfffc",
                    height,
                    width,
                    borderRadius: borderRadius,
                    padding: padding,
                    overflow: "hidden",
                    maxHeight: "calc(100vh - 100px)",
                    boxShadow: '0 0 3rem 1rem rgb(95 95 95 / 25%)',
                    // border: "2px solid #30363a",
                }}
            >
                {withHeader ? <Header /> : <CloseIcon />}
                <div
                    className={style.children}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        flex: 1,
                        // maxHeight: "100%",
                        overflowY: manageScroll ? "scroll" : "hidden",
                        marginTop: withHeader ? 10 : 0,
                    }}
                >
                    {children}
                </div>
                {closerStyle === "done-button" || closerStyle === "button" ? (
                    <Button
                        // classes={classes}
                        color="primary"
                        variant="contained"
                        onClick={() => toggleModal(false)}
                    >
                        {closerLabel || "Done"}
                    </Button>
                ) : null}
            </div>
        </AnimatedModal>
    );
});
